var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#22C55E",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bx-plus-circle.svg"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.8334 5.83337H9.16671V9.16671H5.83337V10.8334H9.16671V14.1667H10.8334V10.8334H14.1667V9.16671H10.8334V5.83337Z",
    fill: "#22C55E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.99996 1.66663C5.40496 1.66663 1.66663 5.40496 1.66663 9.99996C1.66663 14.595 5.40496 18.3333 9.99996 18.3333C14.595 18.3333 18.3333 14.595 18.3333 9.99996C18.3333 5.40496 14.595 1.66663 9.99996 1.66663ZM9.99996 16.6666C6.32413 16.6666 3.33329 13.6758 3.33329 9.99996C3.33329 6.32413 6.32413 3.33329 9.99996 3.33329C13.6758 3.33329 16.6666 6.32413 16.6666 9.99996C16.6666 13.6758 13.6758 16.6666 9.99996 16.6666Z",
    fill: "#22C55E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.243bf146162304649a182c7f38617877.svg";
export { ForwardRef as ReactComponent };